module.exports = __webpack_public_path__ + "static/img/team-member-2.9dcd5ef4.jpg";